import { cn } from '@/utils/functions';

export const LifeBuoyIcon = ( { className } ) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={ cn( 'text-icon-secondary', className ) }
	>
		<path
			d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			stroke="url(#paint0_linear_40756_85495)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
			stroke="url(#paint1_linear_40756_85495)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.92969 4.92969L9.16969 9.16969"
			stroke="url(#paint2_linear_40756_85495)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.8301 14.8281L19.0701 19.0681"
			stroke="url(#paint3_linear_40756_85495)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.8301 9.16969L19.0701 4.92969"
			stroke="url(#paint4_linear_40756_85495)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14.8301 9.17063L18.3601 5.64062"
			stroke="url(#paint5_linear_40756_85495)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.92969 19.0681L9.16969 14.8281"
			stroke="url(#paint6_linear_40756_85495)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_40756_85495"
				x1="2"
				y1="12"
				x2="22"
				y2="12"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_40756_85495"
				x1="8"
				y1="12"
				x2="16"
				y2="12"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_40756_85495"
				x1="4.92969"
				y1="7.04969"
				x2="9.16969"
				y2="7.04969"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_40756_85495"
				x1="14.8301"
				y1="16.9481"
				x2="19.0701"
				y2="16.9481"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_40756_85495"
				x1="14.8301"
				y1="7.04969"
				x2="19.0701"
				y2="7.04969"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
			<linearGradient
				id="paint5_linear_40756_85495"
				x1="14.8301"
				y1="7.40562"
				x2="18.3601"
				y2="7.40562"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
			<linearGradient
				id="paint6_linear_40756_85495"
				x1="4.92969"
				y1="16.9481"
				x2="9.16969"
				y2="16.9481"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
		</defs>
	</svg>
);

export const LightningIcon = ( { className } ) => (
	<svg
		className={ className }
		width="34"
		height="34"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.83618 11.0022C1.67848 11.0027 1.52387 10.9585 1.3903 10.8747C1.25674 10.7908 1.1497 10.6708 1.08163 10.5286C1.01356 10.3863 0.987253 10.2277 1.00576 10.0711C1.02426 9.91445 1.08683 9.7663 1.18618 9.64384L9.43617 1.14384C9.49806 1.0724 9.58239 1.02413 9.67533 1.00695C9.76826 0.989761 9.86428 1.00468 9.94762 1.04926C10.031 1.09383 10.0967 1.16542 10.134 1.25226C10.1712 1.3391 10.1779 1.43604 10.1528 1.52717L8.55284 6.54384C8.50566 6.67011 8.48982 6.80594 8.50667 6.93968C8.52352 7.07342 8.57256 7.20107 8.64958 7.31169C8.72661 7.42231 8.82932 7.5126 8.9489 7.5748C9.06849 7.63701 9.20138 7.66928 9.33618 7.66884H15.1695C15.3272 7.6683 15.4818 7.71252 15.6154 7.79636C15.7489 7.88019 15.856 8.00021 15.9241 8.14246C15.9921 8.28471 16.0184 8.44335 15.9999 8.59996C15.9814 8.75656 15.9189 8.90471 15.8195 9.02717L7.56951 17.5272C7.50762 17.5986 7.42329 17.6469 7.33036 17.6641C7.23742 17.6812 7.1414 17.6663 7.05807 17.6218C6.97473 17.5772 6.90902 17.5056 6.87173 17.4187C6.83444 17.3319 6.82778 17.235 6.85284 17.1438L8.45284 12.1272C8.50002 12.0009 8.51587 11.8651 8.49902 11.7313C8.48217 11.5976 8.43313 11.4699 8.3561 11.3593C8.27907 11.2487 8.17636 11.1584 8.05678 11.0962C7.93719 11.034 7.8043 11.0017 7.66951 11.0022H1.83618Z"
			stroke="url(#paint0_linear_44843_53296)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_44843_53296"
				x1="1"
				y1="9.3355"
				x2="16.0057"
				y2="9.3355"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B809A7" />
				<stop offset="0.46875" stopColor="#E90B76" />
				<stop offset="1" stopColor="#FC8536" />
			</linearGradient>
		</defs>
	</svg>
);

export const CheckIcon = ( { className } ) => (
	<svg
		className={ className }
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_44843_53309)">
			<path
				d="M14.6673 7.38527V7.99861C14.6665 9.43622 14.201 10.8351 13.3402 11.9865C12.4794 13.1379 11.2695 13.9803 9.89089 14.3879C8.51227 14.7955 7.03882 14.7465 5.6903 14.2483C4.34177 13.7501 3.19042 12.8293 2.40796 11.6233C1.6255 10.4173 1.25385 8.99065 1.34844 7.55615C1.44303 6.12165 1.99879 4.75616 2.93284 3.66332C3.86689 2.57049 5.12917 1.80886 6.53144 1.49204C7.93371 1.17521 9.40083 1.32017 10.714 1.90527"
				stroke="#FF6C0A"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6667 2.66797L8 9.3413L6 7.3413"
				stroke="#FF6C0A"
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>

		<defs>
			<clipPath id="clip0_44843_53309">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export const StatusIcon = ( { className } ) => (
	<div
		className={ cn(
			'inline-flex items-center justify-center text-icon-secondary py-1 pl-1 pr-2',
			className
		) }
	>
		<span className="relative size-4 bg-[currentColor] rounded-full shrink-0 before:content-[''] before:absolute before:size-2 before:bg-white before:rounded-full before:left-[25%] before:top-[25%]" />
	</div>
);
